// Components==============
import { faCheck, faPrint, faRepeat } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HomeContext } from 'screens/Home/Home';
import { initialPulse, pulse } from 'utilities/framerAnimations';
import { MenuContext } from '../../Menu';
import CirclesBar from '../CirclesBar/CirclesBar';
import Popup from '../Popup/Popup';
import './Bolt.module.scss';
// =========================

export default function Bolt() {
    const {
        select,
        selected,
        setMenuPointer,
        setSelected,
        setPrintModalIsOpen,
    } = useContext(MenuContext);
    const history = useHistory();

    const { setWelcomeY, welcomeSequence } = useContext(HomeContext);

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (welcomeSequence === 'flits') {
            setWelcomeY(`${ref?.current?.offsetTop!}px`);
        }
    }, [welcomeSequence]);

    const flashExercises = useSelector((state: ReduxStore) =>
        state.authentication?.user?.flash_exercises?.map((exercise) => {
            const isFinished =
                typeof state.authentication?.user?.exercise_status?.find(
                    (e) =>
                        e.exercise_id === exercise?.id &&
                        e.exercise_type.includes('FlashExercise')
                ) !== 'undefined';

            return {
                ...exercise,
                isFinished,
            };
        })
    );

    return (
        <div styleName="wrapper" ref={ref}>
            <motion.button
                animate={welcomeSequence === 'flits' ? pulse : initialPulse}
                initial={initialPulse}
                onClick={(e) => {
                    select('bolt');
                    setMenuPointer(e);
                }}
                type="button"
            >
                <img alt="bolt icon" src="/images/menu/icon-bolt.svg" />
            </motion.button>
            {selected === 'bolt' && (
                <Popup
                    translateY50
                    style={{
                        background: '#181818',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        padding: '0px',
                    }}
                >
                    <CirclesBar>
                        {flashExercises?.length === 0 ? (
                            <p styleName="empty">
                                Er zijn op dit moment geen flits oefeningen
                            </p>
                        ) : (
                            <>
                                {flashExercises?.map((exercise, index) => {
                                    const finished = exercise.isFinished;

                                    const previousItemIsNotFinished =
                                        index > 0 &&
                                        !flashExercises[index - 1].isFinished;

                                    const canRepeat =
                                        exercise.can_repeat && finished;

                                    const cantClick =
                                        !canRepeat &&
                                        (finished || previousItemIsNotFinished);

                                    return (
                                        <CircleButton
                                            key={index}
                                            onClick={() => {
                                                if (cantClick) return;

                                                setSelected('initial');
                                                history.push(
                                                    `/${exercise.treatment_id}/flitsprogramma/${exercise.id}`
                                                );
                                            }}
                                            color={
                                                finished
                                                    ? 'green'
                                                    : previousItemIsNotFinished
                                                    ? 'grey'
                                                    : 'blue'
                                            }
                                            style={{
                                                cursor: cantClick
                                                    ? 'default'
                                                    : 'cursor',
                                            }}
                                        >
                                            {canRepeat ? (
                                                <FontAwesomeIcon
                                                    icon={faRepeat}
                                                />
                                            ) : finished ? (
                                                <FontAwesomeIcon
                                                    icon={faCheck}
                                                />
                                            ) : (
                                                <h6>{index + 1}</h6>
                                            )}
                                        </CircleButton>
                                    );
                                })}
                                <CircleButton
                                    color="blue"
                                    onClick={() => setPrintModalIsOpen(true)}
                                >
                                    <FontAwesomeIcon icon={faPrint} />
                                </CircleButton>
                            </>
                        )}
                    </CirclesBar>
                </Popup>
            )}
        </div>
    );
}
